/**
 * useAuth — consume the AuthContext.
 *
 * Throws if called outside <AuthProvider>.
 */
import { useAuthContext } from './AuthContext'
import type { AuthContextValue } from './AuthContext'

export function useAuth(): AuthContextValue {
  return useAuthContext()
}
